import type { VisualizationJournalEvent } from "@zplanem/responses"
import type React from "react"
import { getTranslations } from "../../../i18n"
import { useLocale } from "../../../locale-context"
import { JournalRowShell } from "../journal-row-shell"
import { interpolate, resolveActor } from "../resolve-actor"

const VisualizationIcon: React.FC = () => (
	<svg
		viewBox="0 0 16 16"
		fill="none"
		stroke="currentColor"
		strokeWidth="1.5"
		strokeLinecap="round"
		strokeLinejoin="round"
		className="w-5 h-5"
		aria-hidden="true"
	>
		<rect x="2" y="3" width="12" height="10" rx="1.5" />
		<path d="m2 10.5 3-3 3 3 2-2 4 4" />
		<circle cx="6" cy="6" r="1" />
	</svg>
)

export function VisualizationEventRow({
	event,
}: {
	event: VisualizationJournalEvent
}) {
	const { locale } = useLocale()
	const t = getTranslations(locale)
	const actor = resolveActor(event.actor, t)
	const copy =
		event.type === "visualization.created"
			? t.journal.events.visualizationCreated
			: t.journal.events.visualizationDeleted
	return (
		<JournalRowShell
			icon={<VisualizationIcon />}
			headline={copy.label}
			actor={actor}
			iso={event.createdAt}
			eventType={event.type}
			aria={interpolate(copy.aria, { actor })}
		/>
	)
}
